import type { Metadata, Viewport } from "next";
import { DM_Sans, JetBrains_Mono } from "next/font/google";
import "./globals.css";
import { AuthBootstrap } from "@/components/auth-bootstrap";

const dmSans = DM_Sans({
  variable: "--font-dm-sans",
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
});

const jetbrainsMono = JetBrains_Mono({
  variable: "--font-jetbrains-mono",
  subsets: ["latin"],
  weight: ["400", "500", "600"],
});

export const metadata: Metadata = {
  title: "Alqove — Resale Marketplace",
  description: "Shop curated resale from verified stores. Sustainable fashion from businesses you can trust.",
};

export const viewport: Viewport = {
  // Brand forest, matching the wordmark — tints mobile browser chrome.
  themeColor: "#1f3a2e",
};

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html
      lang="en"
      className={`${dmSans.variable} ${jetbrainsMono.variable} h-full antialiased`}
    >
      <body className="min-h-full flex flex-col font-sans">
        <AuthBootstrap />
        {children}
      </body>
    </html>
  );
}
